<template>
  <div class="main-banner">
    <div class="main-banner__inner">
      <div class="main-banner__left main-banner__item">
        <div class="main-banner__text">
          <h1 class="main-banner__title">
            {{ $t('banner.title')}}
          </h1>
          <div class="main-banner__description">
            {{ $t('banner.subtitle')}}
          </div>
        </div>
      </div>
      <div class="main-banner__right main-banner__item">
        <img
          class="main-banner__img"
          src="@/assets/img/mainbanner.png"
          alt="banner"
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.main-banner{
    height: 390px;
    &__inner{
        display: flex;
    }
    &__item{
        flex: 1;
    }
    &__title{
        font-style: normal;
        font-weight: 600;
        font-size: 48px;
        line-height: 58px;
        margin-bottom: 16px;
        width: 90%;
    }
    &__description{
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        line-height: 25px;

    }
    &__text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }
}
@media (min-width: 320px) and (max-width: 641px) {
.main-banner{
    &__inner{
        flex-direction: column;
    }
    &__left{
        margin-bottom: 40px;
    }
    &__title{
        font-size: 28px;
        line-height: 34px;
        width: 100%;
    }
    &__description{
        font-size: 16px;
        line-height: 19px;
    }
    &__img{
        max-width: 300px;
        width: 100%;
        height: 205.88px;
        display: block;
        margin: 0 auto;
    }

}
}
@media (min-width: 642px) and (max-width: 768px) {
  .main-banner{
    &__title{
        font-size: 30px;
        line-height: 38px;
        width: 100%;
    }
    &__description{
      font-size: 18px ;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
.main-banner{
    &__title{
        font-size: 36px;
        line-height: 42px;
        width: 100%;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
}
}
</style>
